export { WorkshopsPage } from './pages/WorkshopsPage';
